<template>
<div>
  <!-- 填空题 -->
  <template v-if="question.ques_type == 0">
    <fill-question :question="question" v-on:answer="submit_answer"></fill-question>
  </template>
  <!-- 单选题 -->
  <template v-else-if="question.ques_type == 1">
    <single-choice-question :question="question" v-on:answer="submit_answer"></single-choice-question>
  </template>
  <!-- 多选题 -->
  <template v-else-if="question.ques_type == 2">
    <multi-choice-question :question="question" v-on:answer="submit_answer"></multi-choice-question>
  </template>
  <!-- 日期题 -->
  <template v-else-if="question.ques_type == 'date'">
    <date-question :question="question" v-on:answer="submit_answer"></date-question>
  </template>
</div>
</template>

<script>
import FillQuestion from '@/components/template/question/FillQuestion'
import DateQuestion from '@/components/template/question/DateQuestion'
import SingleChoiceQuestion from '@/components/template/question/SingleChoiceQuestion'
import MultiChoiceQuestion from '@/components/template/question/MultiChoiceQuestion'

export default {
  name: 'Question',
  props: ['question'],
  components: {FillQuestion, DateQuestion, SingleChoiceQuestion, MultiChoiceQuestion},
  data () {
    return {
      question_example: {
        id: 1,
        ques_type: 1,
        option: ['第一个选型', '第二个选型', '第三个选型', '第四个选型'],
        body: '您孩子在51talk学习英语的目的是？'
      }
    }
  },
  methods: {
    submit_answer: function(qid, answer){
      console.log('Get answer: ' + answer + ' From question ' + qid)
      this.$emit('setAnswer', qid, answer)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/template/question/Question.vue